module.exports = __webpack_public_path__ + "918c032492e9e25ff58a5a9904f51293.pdf";